import { SkeletonBar } from '@petsmart-ui/sparky';

import './Loading.scss';

export const Loading = () => {
    return (
        <div className="loading-wrapper">
            <SkeletonBar className="skeleton" />
        </div>
    );
};
